module.exports = __webpack_public_path__ + "assets/img/12_78.74aa42c1.jpg";